export class File {
  public static async downloadPDF(url: string, filename?: string): Promise<boolean> {
    const blob = await fetch(url).then((r) => r.blob());
    if (blob) {
      const file = new Blob([blob], { type: 'application/pdf' });
      const data = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.setAttribute('target', '_blank');
      link.setAttribute('href', data);
      filename && link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return true;
    }
    return false;
  }
}
